import Choices from 'choices.js';
import { enableScroll, disableScroll } from '../global/helpers';
import { breakpoints } from './variables';

class EmLocator {
	isScrollDisabled = false;

	constructor(el) {
		if (el) {
			this.el = el;
			this.countEl = this.el.querySelector('.eml-map__count');
			this.filterEls = this.el.querySelectorAll('.js-eml-locator-filter');
			this.locatorId = this.el.id.replace('js-eml-locator-', '');
			this.EmLocator = window.emlLocators[this.locatorId];
			this.EmLocator.settings.apiUrl = '/wp-json/em-locator/v1/locations/';
			this.filters = [];

			if (this.filterEls.length) {
				this.filterEls.forEach((filter) => {
					this.filters.push({
						el: filter,
						clone: filter.cloneNode(true),
						ChoicesInstance: new Choices(filter, {
							placeholder: true,
							shouldSort: false,
						}),
					});

					filter.addEventListener('change', this.handleFilterChange);
				});

				this.setChoices();

				window.addEventListener('emlPreFetchLocations', this.updateApiUrl);
				window.addEventListener('emlPostFetchLocations', this.updateCount);
				document.addEventListener('click', this.handleClicks);
				window.addEventListener('resize', this.handleResize);

				this.maybeMoveMapEl();
			}
		}
	}

	setChoices = () => {
		// Get all the valid location ids from the selected <option>s data-locations attributes.
		const locationValues = this.getLocationValues();
		// Turn locationValues into a query selector so that we can disable <option>s that don't have those location ids in their data-locations attribute.
		const querySelector = this.getLocationQuerySelector(locationValues);

		this.filters.forEach(({ el, clone, ChoicesInstance }) => {
			// Get the current value for this filter.
			const { value } = el;

			console.log(clone);

			// Convert the HTMLOptionsList into an array.
			const options = Array.from(clone.options);
			// Map the <option>s from the cloned <select> into an array of choices to pass into ChoicesInstance.
			const choices = options.map((option) => {
				console.log(option.selected);
				const choice = {
					value: option.value,
					label: option.innerText,
					selected: option.selected,
				};

				// Select the choice with the current value.
				if (option.value === value) {
					choice.selected = true;
				}

				if (option.selected) {
					choice.selected = true;
				}

				// Check if the <option> matches the querySelector and disable if not.
				if (querySelector && !option.matches(querySelector) && option.value) {
					choice.disabled = true;
				}

				return choice;
			});

			// Clear out the existing choices and replace with the new ones.
			ChoicesInstance.setChoices(choices, 'value', 'label', 'selected', true);
		});
	}

	getLocationValues = () => {
		let locationValues = [];
		this.filters.forEach(({ el, clone }) => {
			// Get the value from the primary <select> element, which only contains the selected <option> after Choices.js is initialized.
			const { value } = el;
			if (value) {
				// Get the selected <option> element from the cloned <select> element, which contains all the original <option>s.
				const selectedOption = clone.querySelector(`option[value="${value}"]`);
				// Only proceed if we have an option and it has a data-locations attribute.
				if (selectedOption && selectedOption.dataset.locations) {
					// data-locations is formatted like so, data-locations="|123||265||987|". This code replaces the pipes and parses into an array.
					const filterLocations = JSON.parse(`[${selectedOption.dataset.locations.replaceAll('||', ',').replaceAll('|', '')}]`);
					// Get location intersections between filters so we can eventually query for and disable filters that don't apply to these locations.
					locationValues = locationValues.length ? locationValues.filter((value) => filterLocations.includes(value)) : filterLocations;
				}
			}
		});

		return locationValues;
	}

	getLocationQuerySelector = (values = []) => {
		const locationValues = values || this.getLocationValues();
		if (locationValues.length) {
			return locationValues.map((location) => `[data-locations*="|${location}|"]`).join(', ');
		}

		return '';
	}

	updateApiUrl = (e) => {
		let { currentUrl } = window.emOptions;
		const locationValues = this.getLocationValues();
		if (locationValues.length) {
			const params = new URLSearchParams();
			params.set('locations', locationValues.join(','));

			// Convert the query params into a string.
			const queryString = params.toString();
			if (queryString) {
				// Update URL in browser.
				currentUrl += currentUrl.indexOf('?') > -1 ? `&${queryString}` : `?${queryString}`;
				window.history.pushState({ path: currentUrl }, '', currentUrl);

				// Update API URL.
				e.detail.apiUrl += e.detail.apiUrl.indexOf('?') > -1 ? `&${queryString}` : `?${queryString}`;
			}
		} else {
			window.history.pushState({ path: currentUrl }, '', currentUrl);
		}
	}

	updateCount = () => {
		const { totalPosts } = this.EmLocator.pagination;
		const resultsText = totalPosts > 1 ? 'Results' : 'Result';
		this.countEl.innerText = `${totalPosts} ${resultsText}`;
	}

	maybeMoveMapEl = () => {
		const { mapEl, mapContainerEl, mapLocationDetailsEl } = this.EmLocator;
		if (breakpoints.sm.aboveMin()) {
			// Move map element to map container.
			mapContainerEl.appendChild(mapEl);
		} else {
			// Move map element to the location details.
			mapLocationDetailsEl.appendChild(mapEl);
		}
	}

	handleResize = () => {
		window.requestAnimationFrame(() => {
			if (breakpoints.sm.aboveMin()) {
				if (this.isScrollDisabled) {
					this.isScrollDisabled = false;
					enableScroll();
				}
			}

			this.maybeMoveMapEl();
		});
	}

	handleClicks = (e) => {
		this.maybeMoveMapEl();
		if (breakpoints.sm.belowMin()) {
			const { target } = e;
			if (target.closest(`#${this.el.id} .eml-locations .eml-location`)) {
				this.isScrollDisabled = true;
				disableScroll();
			} else if (target.closest(`#${this.el.id} .js-eml-map-back-button`)) {
				this.isScrollDisabled = false;
				enableScroll();
			}
		} else if (this.isScrollDisabled) {
			this.isScrollDisabled = false;
			enableScroll();
		}
	}

	handleFilterChange = () => {
		this.setChoices();
		this.EmLocator.getLocations(this.EmLocator.getLat(), this.EmLocator.getLng());
	}
}


document.addEventListener('DOMContentLoaded', () => {
	const locators = document.querySelectorAll('.js-eml-locator');
	if (locators.length) {
		locators.forEach((el) => new EmLocator(el));
	}
});
